<template>
  <div id="allUserDialog">
    <el-tooltip id="allUser" class="item" effect="light" :content="userName" placement="top">
      <el-autocomplete
        :trigger-on-focus="false"
        :fetch-suggestions="querySearchAsync"
        :readonly="inputDis"
        @select="handleSelect"
        :style="{width: myWidth}"
        v-model="userName"
        placeholder="请选择人员"
        class="input-with-select"
      >
        <el-button slot="append" icon="el-icon-close" @click="reset"></el-button>
        <el-button slot="append" icon="el-icon-plus" :disabled="addBtn" @click="alertDialog"></el-button>
      </el-autocomplete>
    </el-tooltip>
    <el-dialog
      id="myDialog"
      :visible.sync="dialogVisible"
      width="360px"
      :before-close="handleClose"
      center
      append-to-body
    >
      <span slot="title" class="dialog-title">
        <el-button type="text" @click="btn1" :class="{btn:isBtn1}">组织</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="text" @click="btn2" :class="{btn:isBtn2}">常用</el-button>
      </span>
      <div v-show="!show" style="text-align: center;">
        <el-input prefix-icon="el-icon-search" placeholder="输入关键字检索" v-model="filterText"></el-input>
        <div style="height:350px;margin-top: 5px;" v-loading="loading">
          <el-scrollbar style="height: 100%;">
            <el-tree
              class="filter-tree"
              :data="data2"
              :props="defaultProps"
              accordion
              :check-strictly="isStrictly"
              show-checkbox
              node-key="Id"
              :filter-node-method="filterNode"
              @check-change="checkChange"
              highlight-current
              ref="companyTree"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="padding-bottom: 0px;">
                  <img v-if="data.Type==1" src="../../assets/img/机构.png" height="20px">
                  <img v-if="data.Type==3" src="../../assets/img/组织.png" height="20px">
                  <myCircle v-model="node.label" v-if="data.Type==2"></myCircle>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div v-show="show" style="text-align: center;">
        <el-input prefix-icon="el-icon-search" placeholder="搜索人员" v-model="filterText1"></el-input>
        <div style="height:350px;" v-loading="loading1">
          <el-scrollbar style="height: 100%;">
            <el-tree
              class="filter-tree"
              :data="data1"
              :props="defaultProps"
              accordion
              :check-strictly="isStrictly"
              show-checkbox
              node-key="Id"
              :filter-node-method="filterNode"
              @check-change="checkChange"
              highlight-current
              ref="companyTree1"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span style="padding-bottom: 0px;">
                  <img v-if="data.Type==16" src="../../assets/img/分类.png" height="20px">
                  <myCircle v-model="node.label" v-if="data.Type==2"></myCircle>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div style="text-align: center;">
        <el-button @click="toClose">清空</el-button>
        <el-button type="primary" @click="toSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllUser,
  GetUserTreeByCustomerGroup
} from "@/api/modules/basicData/personnel";
import { listToTree } from "@/api/modules/basicData/commonData";
import myCircle from "@/components/common/circle";
export default {
  components: {
    myCircle
  },
  name: "selectContactor",
  data() {
    return {
      userName: "",
      dialogVisible: false,
      filterText: "",
      filterText1: "",
      isStrictly: false,
      inputDis: false,
      data2: [],
      data1: [],
      dataList: [],
      addBtn: false,
      editCheckId: "",
      editCheckId1: "",
      loading: false,
      loading1: false,
      editCheckIdArr: [],
      selectedData: [],
      selectedUser: [],
      unverifiedSelectedUser: [],
      defaultProps: {
        id: "Id",
        children: "children",
        label: "Name"
      },
      data: [],
      show: false,
      isBtn1: true,
      isBtn2: false
    };
  },
  props: {
    isRadio: Boolean,
    setWidth: {
      type: String,
      default: "250px"
    },
    userId: {
      type: String,
      default: ""
    },
    idArray: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.debouncedSearch(val);
    },
    filterText1(val) {
      this.debouncedSearch1(val);
    },
    selectedUser: {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.inputDis = true;
        }
      },
      deep: true //深度监听
    },
    idArray: {
      handler(val, oldVal) {
        if (val.length > 0) {
          if (this.dataList.length == 0) {
            getAllUser(this.userId, "", 0)
              .then(res => {
                res.forEach(c => {
                  for (var i = 0; i <= this.idArray.length; i++) {
                    if (c.UserId == this.idArray[i]) {
                      this.unverifiedSelectedUser.push(c);
                      this.selectedUser.push(c);
                    }
                  }
                });
                this.assignmentInput();
              })
              .catch(res => {
                console.log("异常原因：" + res);
              });
          } else {
            this.dataList.forEach(c => {
              for (var i = 0; i <= this.idArray.length; i++) {
                if (c.UserId == this.idArray[i]) {
                  this.unverifiedSelectedUser.push(c);
                  this.selectedUser.push(c);
                }
              }
            });
          }
        } else {
          this.unverifiedSelectedUser = [];
          this.selectedUser = [];
        }
        this.assignmentInput();
      },
      deep: true //深度监听
    }
  },
  created() {
    var _ = require("lodash");
    this.debouncedSearch = _.debounce(this.getUser, 1000);
    this.debouncedSearch1 = _.debounce(this.GetUserByCustomerGroup, 1000);
    this.checkSource();
    this.setOption();
  },
  methods: {
    btn1() {
      this.show = false;
      this.isBtn1 = true;
      this.isBtn2 = false;
    },
    btn2() {
      this.show = true;
      this.isBtn1 = false;
      this.isBtn2 = true;
    },
    querySearchAsync(queryString, cb) {
      getAllUser(this.userId, queryString, 1)
        .then(res => {
          var result = [];
          res.forEach(c => {
            var obj = {};
            if (c.Type == 2) {
              obj.value = c.Name;
              obj.Name = c.Name2;
              obj.Id = c.Id;
              obj.UserId = c.UserId;
              obj.Type = c.Type;
              result.push(obj);
            }
          });
          cb(result);
        })
        .catch(res => {
          console.log("异常原因：" + res);
        });
    },
    handleSelect(item) {
      this.addBtn = false;
      this.inputDis = true;
      this.unverifiedSelectedUser.push(item);
      this.transferValue(this.unverifiedSelectedUser);
    },
    searchTree(val) {
      this.getTreeData(val);
    },
    setOption() {
      if (this.setWidth != "") {
        this.myWidth = this.setWidth;
      }
      if (this.idArray.length > 0) {
        if (this.dataList.length == 0) {
          getAllUser(this.userId, "", 0)
            .then(res => {
              res.forEach(c => {
                for (var i = 0; i <= this.idArray.length; i++) {
                  if (c.UserId == this.idArray[i]) {
                    this.unverifiedSelectedUser.push(c);
                    this.selectedUser.push(c);
                  }
                }
              });
              this.assignmentInput();
            })
            .catch(res => {
              console.log("异常原因：" + res);
            });
        } else {
          this.dataList.forEach(c => {
            for (var i = 0; i <= this.idArray.length; i++) {
              if (c.UserId == this.idArray[i]) {
                this.unverifiedSelectedUser.push(c);
                this.selectedUser.push(c);
              }
            }
          });
          this.assignmentInput();
        }
      }
    },
    checkSource() {
      if (this.isRadio == true) {
        this.isStrictly = true;
      }
    },
    reset() {
      this.addBtn = false;
      this.inputDis = false;
      this.userName = "";
      this.selectedData = [];
      this.selectedUser = [];
      this.unverifiedSelectedUser = []; //待验证值
      this.$emit("getValue", this.selectedUser, function(str) {
        //传递值，无论是否验证
        console.log("清理完成");
      });
    },
    //实现单双选以及过滤非人员
    checkChange(item, node, self) {
      if (!this.show) {
        if (this.isRadio == true) {
          if (node == true) {
            //点击未选中复选框
            if (item.Type == 2) {
              this.editCheckId = item.Id;
              this.$refs.companyTree.setCheckedKeys([item.Id]);
            } else {
              if (this.editCheckId != "") {
                this.$refs.companyTree.setCheckedKeys([this.editCheckId]);
              } else {
                this.$refs.companyTree.setCheckedKeys([]);
              }
            }
          }
        }
      } else {
        if (this.isRadio == true) {
          if (node == true) {
            //点击未选中复选框
            if (item.Type == 2) {
              this.editCheckId1 = item.Id;
              this.$refs.companyTree1.setCheckedKeys([item.Id]);
            } else {
              if (this.editCheckId1 != "") {
                this.$refs.companyTree1.setCheckedKeys([this.editCheckId1]);
              } else {
                this.$refs.companyTree1.setCheckedKeys([]);
              }
            }
          }
        }
      }
    },
    alertDialog() {
      if (this.data2.length == 0) {
        this.getTreeData("");
      }
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.filterText = "";
      this.editCheckId = "";
      this.$refs.companyTree.setCheckedKeys([]);
      done();
    },
    open(title, message) {
      this.$alert(message, title, {
        confirmButtonText: "确定"
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
    getTreeData(keyword) {
      var _this = this;
      this.getUser(keyword);
      this.GetUserByCustomerGroup(keyword);
    },
    getUser(keyword) {
      this.loading = true;
      getAllUser(this.userId, keyword).then(response => {
        this.dataList = response;
        this.data2 = listToTree("Id", "Pid", this.dataList);
        this.loading = false;
      });
    },
    GetUserByCustomerGroup(keyword) {
      this.loading1 = true;
      GetUserTreeByCustomerGroup(this.userId, keyword).then(response => {
        let dataArray = response;
        this.data1 = listToTree("Id", "Pid", dataArray);
        this.loading1 = false;
      });
    },
    toSure() {
      this.userName = "";
      if (this.show) {
        this.selectedData = this.$refs.companyTree1.getCheckedNodes();
      } else {
        this.selectedData = this.$refs.companyTree.getCheckedNodes();
      }
      // 验证前清空上次选择的人员
      this.unverifiedSelectedUser = [];
      var arr = this.filter(this.selectedData, this.selectedUser);
      arr.forEach(c => {
        this.unverifiedSelectedUser.push(c); //存入未验证数组
      });
      if (this.transferValue(this.unverifiedSelectedUser) == true) {
        this.assignmentInput();
        this.toClose();
        this.dialogVisible = false;
      }
    },
    transferValue(unverifiedData) {
      let isValidate = true; //验证是否通过
      this.$emit("getValue", unverifiedData, function(str) {
        //传递值，无论是否验证
        isValidate = str;
      });
      if (isValidate) {
        //验证通过
        //内外公共操作一起处理
        this.selectedUser = this.unverifiedSelectedUser; //最终值进行处理
        return true;
      } else {
        //验证不通过
        this.unverifiedSelectedUser = [];
        return false;
      }
    },
    assignmentInput() {
      // 赋值前清空文本，去重
      this.userName = "";
      let selectedUser = [];
      this.selectedUser.forEach(user => {
        if (selectedUser.findIndex(_user => _user.IdType == user.IdType) < 0) {
          selectedUser.push(user);
        }
      });
      if (this.isRadio && selectedUser.length > 0) {
        selectedUser = [selectedUser[0]];
      }
      this.selectedUser = selectedUser;
      //input框赋值
      this.selectedUser.forEach(c => {
        this.userName += c.Name + ",";
      });
      this.userName = this.userName.substring(
        0,
        this.userName.lastIndexOf(",")
      );
    },
    toClose() {
      //关闭弹窗
      this.filterText = "";
      this.filterText1 = "";
      this.editCheckId = "";
      this.editCheckId1 = "";
      this.$refs.companyTree.setCheckedKeys([]);
      this.$refs.companyTree1.setCheckedKeys([]);
    },
    filter(arr1, arr2) {
      /*arr1 传被检测对象，arr2传已存在的列表*/
      var arrRet = [];
      for (var j = 0; j < arr1.length; j++) {
        var b = false;
        for (var i = 0; i < arr2.length; i++) {
          if (arr1[j].Type == 1 || arr1[j].Type == 3) {
            b = true;
            break;
          }
          if (arr1[j].UserId == arr2[i].UserId) {
            b = true;
            break;
          }
        }
        if (!b && arr1[j].Type == 2) {
          arrRet.push(arr1[j]);
        }
      }
      return arrRet;
    }
  },
  computed: {}
};
</script>

<style scoped>
#allUser .el-scrollbar__wrap {
  overflow-x: hidden;
}

#allUser .el-button {
  padding: 12px 10px;
}

#myDialog .el-button--text {
  color: darkgray;
  font-size: 20px;
}

#myDialog .el-dialog--center .el-dialog__body {
  padding: 0px 25px 30px;
}

#myDialog .el-input__inner {
  border-radius: 18px;
  width: 210px;
}

#myDialog .el-input {
  width: 210px;
}

#myDialog .el-tree-node__content {
  height: 40px;
}

#myDialog .el-tree-node__expand-icon {
  font-size: 18px;
}

#myDialog .el-tree-node__label {
  font-size: 16px;
}

#myDialog .custom-tree-node {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  padding-right: 8px;
}

#myDialog .custom-tree-node img {
  vertical-align: top;
  margin-top: 4px;
}

#myDialog .el-button {
  border: 0px solid #c2c7d3;
}

#myDialog .btn {
  color: #409eff !important;
}
</style>